module.exports = __webpack_public_path__ + "img/pdf_preview_principles_apc_en.6dd106d3.png";